import { render, staticRenderFns } from "./RecentOperationsResults.vue?vue&type=template&id=6464abf5"
import script from "./RecentOperationsResults.vue?vue&type=script&lang=js"
export * from "./RecentOperationsResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports